module.exports = __webpack_public_path__ + "img/D202210_3.d2bcb14b.jpg";